import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { CompanyBasic, CreateTradeRestriction, Person, TradeRestriction } from '../../models';
import { Subject } from 'rxjs';
import { TradeRestrictionReason, TradeRestrictionReasonLabels } from '../../enums/trade-restriction-reason.enum';
import { TradeRestrictionLevel, TradeRestrictionLevelLabels } from '../../enums/trade-restriction-level.enum';
import { RestrictionsIntegrationService } from '../../../modules/restrictions/restrictions-integration.service';
import { environment } from 'src/environments/environment';
import { ModalSuggestion } from '../../models/restrictions/modal-suggestion.model';
import { DateTime } from 'luxon';
import { RMS_SHEET_MODAL_CLASS } from '../../constants/sheet-modal';

@Component({
    selector: 'rms-restriction-add-edit',
    templateUrl: './restriction-add-edit.component.html',
    styleUrls: ['./restriction-add-edit.component.scss'],
    standalone: false
})
export class RestrictionAddEditComponent implements OnInit {

  @ViewChild('restrictionAddEditModal', { static: true }) modal: ElementRef;
  private modalRef: NgbModalRef;

  public tradeRestriction: TradeRestriction = new TradeRestriction();

  public companyTypeahead = new Subject<string>();
  public companies: Array<any>;

  public people: Array<Person> = new Array<Person>();

  public startDate: DateTime;
  public endDate: DateTime;
  public maxEndDate: DateTime = DateTime.now().toLocal();

  public editMode = false;

  public forceEzeError = false;

  public readonly environment = environment;
  public readonly restrictionTypes = Object.values(TradeRestrictionReason).filter(r => r !== TradeRestrictionReason.BOARD);
  public readonly TradeRestrictionReasonLabels = TradeRestrictionReasonLabels;
  public readonly restrictionLevels = Object.values(TradeRestrictionLevel);
  public readonly TradeRestrictionLevelLabels = TradeRestrictionLevelLabels;
  public readonly CompanyBasic = CompanyBasic;
  public readonly fixedReasonLevels: Map<TradeRestrictionReason, TradeRestrictionLevel> =
    new Map<TradeRestrictionReason, TradeRestrictionLevel>([
      [TradeRestrictionReason.OTW, TradeRestrictionLevel.HARD],
      [TradeRestrictionReason.MNPI, TradeRestrictionLevel.HARD],
      [TradeRestrictionReason.BOARD, TradeRestrictionLevel.SOFT],
    ]);

  constructor(
    private modalService: NgbModal,
    private restrictionsIntegrationService: RestrictionsIntegrationService
  ) { }

  ngOnInit() {
    this.restrictionsIntegrationService.people.subscribe(resp => {
      this.people = resp;
    });
  }

  public openModal(tradeRestriction?: TradeRestriction, suggestedModalData?: ModalSuggestion) {
    if (tradeRestriction) {
      this.tradeRestriction = new TradeRestriction(tradeRestriction);
      this.startDate = this.tradeRestriction.startDate;
      this.endDate = this.tradeRestriction.endDate;
      if (this.fixedReasonLevels.has(this.tradeRestriction.reason)) {
        this.tradeRestriction.level = this.fixedReasonLevels.get(this.tradeRestriction.reason);
      }
      this.editMode = true;
    } else {
      this.tradeRestriction = new TradeRestriction();
      this.startDate = DateTime.now();
      this.endDate = null;
      this.tradeRestriction.level = TradeRestrictionLevel.HARD;
      this.tradeRestriction.company = suggestedModalData.company;
      this.tradeRestriction.person = suggestedModalData.person;
    }
    this.modalRef = this.modalService.open(this.modal, { size: 'lg', centered: true, fullscreen: 'sm', windowClass: RMS_SHEET_MODAL_CLASS });
    return this.modalRef;
  }

  public submit(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.tradeRestriction.startDate = this.startDate;
    this.tradeRestriction.endDate = this.endDate;
    const restriction = new CreateTradeRestriction(this.tradeRestriction);
    restriction['forceEzeError'] = this.forceEzeError;
    this.modalRef.close(restriction);
  }

  public filterOutPrivateCompanies(company: CompanyBasic) {
    return !company.isPrivate;
  }
}
